import { loadAudioSounds } from "helpers/sounds";
import React from "react";
import { useDispatch } from "react-redux";
import { takeMyPic, stopUseCamera } from "slices/createPictureSlice";
import { setDeviceSettingsModal } from "slices/extraOptionsSlice";

const TakePicControls = () => {
  const dispatch = useDispatch();
  return (
    <div>
      <button
        className="snap-button"
        onClick={() => {
          dispatch(takeMyPic());
        }}
      >
        Snap
      </button>
      <br></br>
      <button
        className="cancel-button"
        onClick={() => {
          dispatch(stopUseCamera());
        }}
      >
        Cancel
      </button>
      <br></br>
      <button
        className="change-cam-button"
        onClick={() => {
          loadAudioSounds();
          dispatch(setDeviceSettingsModal(true));
        }}
      >
        change camera
      </button>
      <br></br>
    </div>
  );
};

export default TakePicControls;
